












import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseIcon from '../base-icon/_base-icon.vue';
import BaseH4 from '../base-headings/_base-h4.vue';
import BaseParagraph from '../base-paragraph/_base-paragraph.vue';

@Component({
  name: 'BaseInfoMessage',
  components: {
    BaseIcon,
    BaseH4,
    BaseParagraph,
  },
})
export default class BaseInfoMessage extends Vue {
  @Prop() title: string;
}
